const blur = {
  none: 0,
  sm: "0.0625rem",
  md: "0.125rem",
  lg: "0.25rem",
};

export default blur;
